import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Group} from '../models/group';
import { ResourceService } from '../../../core/services/resource.service';
import { map, Observable, from, throwError } from 'rxjs';
import { shareReplay, take, filter, switchMap } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogConfig, ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { AlertDialog, AlertDialogConfig } from '../components/alert/dialog';

@Injectable({ providedIn: 'root' })
export class GroupService extends ResourceService<Group> {
  constructor( private readonly dialog_: MatDialog, private http: HttpClient,
    private configService: AppConfigService, ) {
    super(
      http,
      Group,
      'groups'
    );
  }

  public addGroup(object: any): Observable<any> {
    return  from(this.api
      .post('route-api', `groups`, {
        body: object
      })
      );
  }

  public addUser(object: any): Observable<any> {
    return  from(this.api
      .put('route-api', `groups/${object.group}/users`, {
        body: object
      })
      );
  }

  public addResource(object: any): Observable<any> {

    return  from(this.api
      .put('route-api', `groups/${object.group}/resources`, {
        body: object
      })
      )
  }


  public deleteResourceOfGroup(object: any): Observable<any> {

    const config = {
      title: 'Confirmer',
      message: 'Souhaitez-vous confirmer la suppression de la ressource '+ object.name+ ' du groupe '+object.group+' ?',
    } as ConfirmDialogConfig;

    // urlize object.name
    object.name = encodeURIComponent(object.name);

    return this.dialog_
    .open(ConfirmDialogComponent, {data: config})
    .afterClosed()
    .pipe(filter(result => result))
    .pipe(
      switchMap(_ => {

        return  from(this.api
          .del('route-api', `groups/${object.group}/resources/${object.name}`, {

          })
          )
          })
          )

          ;
  }



  public deleteUserOfGroup(object: any): Observable<any> {

    const config = {
      title: 'Confirmer',
      message: 'Souhaitez-vous confirmer la suppression de l\'utilisateur '+ object.email+ ' du groupe '+object.group+' ?',
    } as ConfirmDialogConfig;

    return this.dialog_
    .open(ConfirmDialogComponent, {data: config})
    .afterClosed()
    .pipe(filter(result => result))
    .pipe(
      switchMap(_ => {

        return  from(this.api
          .del('route-api', `groups/${object.group}/users/${object.email}`, {

          })
          )
          })
          )

          ;
  }

  public getUsersOf(id: string): Observable<any> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/${id}/users`, {}))
      .pipe<any>(map(result => result.resource));
  }

  public getResourcesOf(id: string): Observable<any> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/${id}/resources`, {}))
      .pipe<any>(map(result => result.resource));
  }

}


